// Generate code from clean architecture template

import { CourseEntity } from '@/domains/course/entities';
import {
  CoursePayloadForm,
  QueryCoursePayload,
  QueryCoursesOutput,
} from '@/domains/course/ports/payloads';
import { CourseRepository } from '@/domains/course/ports/repositories';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import { CREATE_COURSE, DETAIL_COURSE, GET_COURSE_ITEMS, UPDATE_COURSE } from '../../graphql';

export class CourseHttpRepository implements CourseRepository {
  async getListCourse(payload?: QueryCoursePayload): Promise<QueryCoursesOutput> {
    const { name, shortName, numberOfSession, sessionHour, isActive, page, limit } = payload || {};
    const filter = { name, shortName, numberOfSession, sessionHour, isActive };
    const response: QueryCoursesOutput = await HttpClientAdapter.query<QueryCoursesOutput>({
      query: GET_COURSE_ITEMS,
      dataKey: 'Course_getList',
      variables: { query: { filter, page, limit, sortBy: ['updatedAt|desc'] } },
    });
    return response;
  }

  async createCourse(payload: CoursePayloadForm): Promise<CourseEntity> {
    const response = await HttpClientAdapter.mutate<CourseEntity>({
      mutation: CREATE_COURSE,
      variables: { payload: payload },
    });
    return response;
  }

  async updateCourse(payload: CoursePayloadForm): Promise<CourseEntity> {
    const response: CourseEntity = await HttpClientAdapter.mutate<CourseEntity>({
      mutation: UPDATE_COURSE,
      variables: { payload: payload },
    });
    return response;
  }

  async getDetailCourse(payload: string): Promise<CourseEntity> {
    const response: CourseEntity = await HttpClientAdapter.query<CourseEntity>({
      query: DETAIL_COURSE,
      dataKey: 'Course_getById',
      variables: { id: payload },
    });
    return response;
  }
}
